import { OptionalGroupRepository } from "core/repository";
import { OptionalGroup } from "core/entity";
import { Base2Presenter } from "core/presenter";

export default class ProductInfoPresenter extends Base2Presenter {
  initialState() {
    return {
      form: new OptionalGroup(),
      loading: true,
      title: "Novo Grupo de Opcionais",
      optionalGroupUuid: ""
    };
  }

  async onStart() {
    const optionalGroupUuid = this.routeParams.optionalGroupUuid;
    this.enqueue({ optionalGroupUuid });

    await this.loadOptionalGroup(optionalGroupUuid);
  }

  async loadOptionalGroup(optionalGroupUuid) {
    this.enqueue({ loading: true });
    const result = await OptionalGroupRepository.getOptionalGroup(
      optionalGroupUuid
    );

    if (result.success) {
      this.enqueue({ form: result.data });
    } else {
      this.sendNotification({
        type: "error",
        title: "Oooops...",
        content:
          "Não conseguimos carregar este grupo de opcionais! Tente novamente em alguns minutos."
      });
    }

    this.enqueue({ loading: false });
  }

  async onDeleteOptionalGroup() {
    const optionalGroup = this.viewModel.form;

    this.sendNotification({
      type: "confirmation",
      title: "Você tem certeza?",
      content: `Tem certeza que deseja excluir o grupo de opcionais ${optionalGroup.name ||
        "Sem nome"}?`,
      actions: [
        {
          label: "Voltar"
        },
        {
          label: "Sim, quero excluir",
          type: "accent",
          callback: () => this.doDeleteOptionalGroup(optionalGroup)
        }
      ]
    });
  }

  async doDeleteOptionalGroup(optionalGroup) {
    this.enqueue({ loading: true });

    const repositoryResult = await OptionalGroupRepository.deleteOptionalGroup(
      optionalGroup.uuid,
      optionalGroup
    );

    if (repositoryResult.success) {
      this.sendNotification({
        type: "success",
        content: "O grupo de opcionais foi excluído."
      });
      this.onGoBack();
    } else if (repositoryResult.fatal) {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content: "Ocorreu um erro na conexão. Tente novamente mais tarde."
      });
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content: repositoryResult.error
      });
    }

    this.enqueue({ loading: false });
  }

  onGoBack() {
    this.navigateTo("app.registration.optional_group");
  }

  onEdit() {
    this.navigateTo("app.registration.optional_group.edit", {
      optionalGroupUuid: this.viewModel.form.uuid
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/optional-groups/info/presenter.js